import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import { classnames } from '@/utils/classnames';
import { range } from '@/utils/object';
import styles from '../../../styles/animation.module.css';
import { TPasscodeVariant } from '../PasscodeKeypad';

export interface IPasscodePreviewProps {
  length: number;
  value: string;
  timeout?: number;
  variant?: TPasscodeVariant;
}

const variantClassNames = {
  default: '!bg-gray-40',
  success: '!bg-green-50',
  error: classnames('!bg-red-50', styles['shake-horizontal']),
};

const PasscodePreview: FC<IPasscodePreviewProps> = ({
  length,
  value,
  timeout = 0,
  variant = 'default',
}) => {
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const timeoutRef = useRef<number>(0);
  const previousValueRef = useRef<string>('');

  useLayoutEffect(() => {
    window.clearTimeout(timeoutRef.current);
    const isForwarded: boolean = previousValueRef.current.length < value.length;

    if (timeout && isForwarded) {
      setShowPreview(true);
      timeoutRef.current = window.setTimeout(() => {
        setShowPreview(false);
      }, timeout);
    }

    previousValueRef.current = value;
  }, [timeout, value]);

  return (
    <div className="flex flex-row gap-x-[32px] ltr">
      {range(1, length).map((number) => {
        const isLastFilled: boolean = number === value?.length;
        const shouldFilled: boolean = number <= value?.length;

        return (
          <div key={number} className="flex h-[16px] w-[16px] children:flex-1">
            {isLastFilled && showPreview ? (
              <div className="flex items-center justify-center text-base font-medium text-gray-90">
                {value[value.length - 1]}
              </div>
            ) : (
              <div
                className={classnames(
                  'rounded-full border-solid border-gray-20',
                  shouldFilled
                    ? variantClassNames?.[variant]
                    : 'border-2 !bg-[#fff] '
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PasscodePreview;
